import { Entity, IEntity } from '@lycoris-nubila/ngx-lycoris';
import { Observable, of } from 'rxjs';

import { ModuleGraphType } from 'module/page/graph/model/module-graph.type';

import { IModuleGraphI18n, ModuleGraphI18n } from './module-graph-i18n';

export interface IModuleGraph extends IEntity {
	readonly colors: string;
	readonly formula: string;
	readonly moduleId: string;
	readonly type: ModuleGraphType;
	readonly localizations: ReadonlyArray<IModuleGraphI18n>;
	readonly localization$: Observable<IModuleGraphI18n>;
	readonly chartJsType: string;
}

export class ModuleGraph extends Entity implements IModuleGraph {
	private _colors: string;
	private _formula: string;
	private _moduleId: string;
	private _type: ModuleGraphType;
	private _localizations: ModuleGraphI18n[];
	private _localization$: Observable<ModuleGraphI18n>;

	constructor(
		id: string,
		colors: string,
		formula: string,
		moduleId: string,
		type: ModuleGraphType,
		updateTimestamp: number,
		localizations: ModuleGraphI18n[],
		localization$: Observable<ModuleGraphI18n> = of(null)
	) {
		super(id, null, updateTimestamp);

		this._type = type;
		this._colors = colors;
		this._formula = formula;
		this._moduleId = moduleId;
		this._localizations = localizations;
		this._localization$ = localization$;
	}

	public get colors(): string {
		return this._colors;
	}

	public get formula(): string {
		return this._formula;
	}

	public get moduleId(): string {
		return this._moduleId;
	}

	public get type(): ModuleGraphType {
		return this._type;
	}

	public get localizations(): ModuleGraphI18n[] {
		return this._localizations;
	}

	public get localization$(): Observable<ModuleGraphI18n> {
		return this._localization$;
	}

	public get chartJsType(): string {
		switch (this.type) {
			case ModuleGraphType.DOUGHNUT:
				return 'doughnut';
			case ModuleGraphType.RADAR:
				return 'radar';
			case ModuleGraphType.LINE:
				return 'line';
			case ModuleGraphType.PIE:
				return 'pie';
			case ModuleGraphType.BAR:
				return 'bar';
			case ModuleGraphType.BAR_STACKED:
				return 'bar';
			case ModuleGraphType.POLAR_AREA:
				return 'polarArea';
		}
	}
}
